import React, { FC, useCallback } from 'react';
import { Form, Select } from 'src/common';
import { AggregateBy } from './types';
import { RenderDOMFunc } from 'rc-select/lib/BaseSelect';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

export const AggregateSelect: FC = () => {
  const { t } = useTranslation();
  const getPopupContainer: RenderDOMFunc = useCallback(trigger => trigger.parentNode, []);
  return (
    <Form.Item name={'aggregateBy'}>
      <Select
        getPopupContainer={getPopupContainer}
        bordered={false}
        dropdownMatchSelectWidth={false}
        suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
      >
        <Select.Option value={AggregateBy.SearchProfile}>{t('KeywordSearch.groups')}</Select.Option>
        <Select.Option value={AggregateBy.Documents}>{t('KeywordSearch.documents')}</Select.Option>
      </Select>
    </Form.Item>
  );
};

export default AggregateSelect;
